import pkg from '../package.json';
import './dfp-pixel';
import Publicidad from './publicidad';
import {CONFIG_NAMESPACE} from './constants';

Voonto.ready.then((app) => {
  const config = app.lookup(CONFIG_NAMESPACE);

  if (!config.media || !config.options) {throw Error('[Ads Manager] missing configuration');}

  new Publicidad(app, config.media, config.options, false);

  Voonto.$('[data-voc-vam]').each(function() {
    Publicidad.printAds(Voonto.$(this), false);
  });

  app.on('vam:refresh', function(event, data) {
    data = typeof data === 'string' ? JSON.parse(data) : data;
    Publicidad.printAds(data);
  });
});

export const VERSION = pkg.version;



// WEBPACK FOOTER //
// ./src/index.js